let defaultLandOwnership = {
    title: '',
    order: 0,
};

export default defaultLandOwnership;

